// extracted by mini-css-extract-plugin
module.exports = {"messageItem":"MessageItem_messageItem__2ySxM","outgoingMessage":"MessageItem_outgoingMessage__1o0j8"};